import { ISystemLanguage } from '../interfaces/ISystemLanguage';

export default class SystemLanguage implements ISystemLanguage
{
  culture: string;
  name: string;
}
